import {View} from 'MWC';
import tpl from '../templates/vacanciesList.jsx';
import buildUrl from 'utils/buildGetURLWithParams';
import {apiback} from '../../../config';
import {LANG} from '../../../services/l10n';
import PropTypes from 'prop-types';
import {VacancyModifierHelper} from '../helper/vacancy-modifier.helper';

export const startPage = 1;
export const startOffset = 0;
export const visiblePages = 5;

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            isShowFilter: false,
            vacancies: [],
            total: 0,
            totalPages: 0,
            limit: 6,
            offset: startOffset,
            page: startPage,
            sort_by: ['date'],
            order_by: ['DESC'],
            visiblePages: visiblePages,
            name: null,
            preload: true
        };
        this.selectPage = this.selectPage.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.model = this.getModel();
        return this;
    }

    toggleFilter(e) {
        if (
            e.target.classList.contains('dropdown-title') ||
            e.target.classList.contains('dropdown')
        ) {
            this.setState({isShowFilter: !this.state.isShowFilter});
        }
    }

    componentDidMount() {
        this.getVacancies();
    }

    getVacancies = () => {
        this.setState({preload: true}, () => {
            const {limit, offset, sort_by, order_by} = this.state,
                params = this.model.getParams(),
                pageParams = {limit, offset, sort_by, order_by};

            let paramsStr;
            for (const key in params) {
                let param;
                if (!params[key]) {
                    delete params[key];
                } else if (key === 'name') {
                    param = `where_like[]=${key}_ua&where_like_by[]=${params[key]}`;
                } else if (key === 'city') {
                    param = `where_by[]=cities.id&search_by[]=${params[key]}`;
                } else if (key === 'hot') {
                    param = `where_by[]=${key}&search_by[]=${params[key]}`;
                } else {
                    param = `where_by[]=${key}.id&search_by[]=${params[key]}`;
                }
                if (param) {
                    paramsStr = paramsStr ? paramsStr + '&' + param : '&' + param;
                }
            }
            const url = buildUrl(apiback('API_VACANCIES'), pageParams),
                finalUrl = paramsStr ? url + paramsStr : url;

            fetch(finalUrl)
                .then(res => res.json())
                .then(({data, total}) => {
                    const vacancies = data ? VacancyModifierHelper.generateTagsInCities(data) : [];
                    this.setState(
                        {
                            vacancies: vacancies || [],
                            total,
                            totalPages: Math.ceil(total / this.state.limit),
                            preload: false
                        },
                        () => window.scrollTo(0, 0)
                    );
                });
            // .catch(x => console.log('error:', x)); //todo добавить обработчик
        });
    };

    resetPage() {
        this.setState({page: startPage, offset: startOffset});
    }

    selectPage(page) {
        this.setState({page: page, offset: page * this.state.limit - this.state.limit}, () =>
            this.getVacancies()
        );
    }

    changeFilter = event => {
        this.resetPage();
        const {target} = event,
            {name} = target?.props || target,
            {value, checked} = target;

        if (name === 'hot') {
            this.model.setParam(checked, name);
            this.getVacancies();
        }
        if (value && name !== 'hot') {
            this.model.setParam(value, name);
            this.getVacancies();
        } else if (event.nativeEvent?.type === 'input') {
            this.model.setParam(value, name);
            this.getVacancies();
        }
    };

    clearFilters = () => {
        this.resetPage();
        this.model.resetParams();
        this.getVacancies();
    };

    static contextTypes = {
        app: PropTypes.object
    };
}
